import { BaseStyles } from "./base"

export const PublicStyles = BaseStyles
